<template>
  <div>
    <CModal
      centered
      :show.sync="showModal"
      :draggable="false"
      :show-footer="false"
      :close-on-backdrop="false"
      @update:show="$emit('close')"
    >
      <template #header-wrapper>
        <header class="modal-header process-bar-header" ref="modalHeader">
          <h5 class="modal-title">
            {{$t(title)}}
          </h5>
        </header>
      </template>
      <template slot="body-wrapper">
        <div class="w-100 p-2 text-center">
          <div class="w-100 text-center p-2">
            <div
              class="w-100 text-center custom-height border-process-bar-parent process-bar-border-radius"
              style="padding: .25rem"
            >
              <div class="process-bar process-bar-border-radius" :style="processBarStyles" />
            </div>
          </div>
          <div class="w-100 p-3">
            <div class="w-100 text-center p-1" v-if="!['success', 'error'].includes(step)">
              {{ $t(stepsText[step]) }} {{ fileName ? `(${fileName})` : '' }}
            </div>
            <div v-if="step === 'success'" class="w-100 text-center p-1 text-success">
              {{ successText ? $t(`${successText}`) : $t(stepsText[step]) }}
            </div>
            <div v-if="step === 'error'" class="w-100 text-center p-1 text-danger">
              {{ errorText ? $t(`${errorText}`) : $t(stepsText[step]) }}
            </div>
            <div v-if="['success', 'error'].includes(step)" class="w-100 text-center p-1">
              <CButton
                color="primary"
                @click="$emit('close')"
              >
                {{ $t('Close') }}
              </CButton>
            </div>
          </div>
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
  name: "ProcessBarModal",
  props: {
    title: String,
    showModal: Boolean,
    successText: {
      type: String,
      required: false
    },
    errorText: {
      type: String,
      required: false
    },
    fileName: {
      type: String,
      required: false
    },
    step: String,
    progress: Number,
    stepsText: Object
  },
  computed: {
    processBarStyles() {
      return {
        width: this.progress + '% !important',
        height: '100% !important'
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

.process-bar-header {
  color: #fff !important;
  background-color: #23145f !important;
  border-color: #23145f !important;
}

.process-bar {
  background-color: $primary;
  transition: 0.3s linear;
}

.custom-height {
  height: 20px;
}

.border-process-bar-parent {
  border: 2px solid $grey-3;
}

.process-bar-border-radius {
  border-radius: .5rem;
}
</style>
